import React, {Component} from "react";
import {Table, Thead, Tbody, Tr, Th, Td} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import axios from "axios";
import fileDownload from "js-file-download";
import {ProfessionalActionTypes} from "../../../store/professionals/actionTypes";
import {Button} from "reactstrap";
import RemoveList from "../../../components/RemoveList/RemoveList";
import QRCodeView from "../../../components/QRCode/QRCodeView";
import {connect} from "react-redux";
import {getTypeTranslation} from "../../../store/translations/actions";
import ShelterStatistic from "./ShelterStatistic";
import {approveProfessional} from "../../../store/professionals/actions";
import {createProfessionalMetaHeadData} from "../../../store/metaHead/actions";
import ProfessionalEdit from "../../Professionals/List/ProfessionalEdit";
import dayjs from "dayjs";
import { formatMoney } from "helpers/currency";
import {userRols} from "../../../helpers/userRols";
import { feeTypeLabel } from "helpers/financial_settings_helper";
import { userStatus } from "helpers/userStatus";

class ShelterList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditModalOpen: false,
      isRemoveModalOpen: false,
      isServiceEditModalOpen: false,
      isStatisticModalOpen: false,
      removeHotel: null,
      editHotel: null,
      defaultValues: {metadata: {services: [{serviceName: '', price: 0, duration: 20}]}},
      hotelsListData: [],
      title: '',
      subTitle: '',
      status: ''
    };
    this.onEditOpen = this.onEditOpen.bind(this);
    this.onEditSubmit = this.onEditSubmit.bind(this);
    this.onRemoveOpen = this.onRemoveOpen.bind(this);
    this.onRemoveSubmit = this.onRemoveSubmit.bind(this);
    this.specializationFileDownload =
      this.specializationFileDownload.bind(this);
    this.onDeclineAccount = this.onDeclineAccount.bind(this);
  }

  componentDidMount() {
    this.props.getTypeTranslation({type: userRols.shelter});
  }

  onEditOpen(shelter) {
    this.setState((prevState) => ({
      isEditModalOpen: !prevState.isEditModalOpen,
      editHotel: shelter,
    }));

    if(this.state.isEditModalOpen) {
      window.location.reload()
    }
  }

  specializationFileDownload(fileUrl, nameFile) {
    const fileName = nameFile;
    const fileExtention = fileUrl.substr(fileUrl.lastIndexOf(".") + 1);
    axios
      .get(fileUrl, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, `${fileName}.${fileExtention}`);
      });
  }

  onDeclineAccount(declineAccount) {
    this.props.approveProfessional(declineAccount)

  }

  onRemoveOpen(professional, title, subTitle, status) {
    this.setState((prevState) => ({
      isRemoveModalOpen: !prevState.isRemoveModalOpen,
      removeHotel: professional,
      title,
      subTitle,
      status
    }));
  }

  onRemoveSubmit(shelter) {
    console.log(shelter)
    this.props.onRemoveItem(shelter);
    // window.location.reload()

  }

  onApproveSubmit = (professional) => {
    this.props.onApproveItem(professional);
    // window.location.reload()

  }

  onEditSubmit(shelter) {
    this.props.onEditItem(shelter);
    // window.location.reload()

  }
  onStatisticOpen = (statistic) => {
    this.setState((prevState) => ({
      isStatisticModalOpen: !prevState.isStatisticModalOpen,
      editHotel: statistic,
    }));
  }
  getHotelsList(shelterListData) {
    if (shelterListData) {
      const hotelListView = [];
      shelterListData.forEach((user, i) => {
        if (user.role === userRols.shelter) {
          const userApproved = userStatus(user.approved);

          hotelListView.push(
            <Tr key={user._id}>
              <Th>{user.name}{' '}{user.surname}<br/><br/>{user.telephone}</Th>
              <Th>{user.email}
                <br/>
                <br/>{user.metadata && user.metadata?.QRMetadata &&
                  <QRCodeView qrcode={user.metadata?.QRMetadata} i={i}/>}</Th>
            <Th>
              {user?.metadata?.fee && user?.metadata.feeType === "SUBSCRIPTION" && (
                <React.Fragment>
                  <br/>
                  <b>{`${feeTypeLabel(user?.metadata.feeType)} ${formatMoney(user?.metadata.fee.feeAmount, { locale: "bg" })}`}</b>
                  <br />
                  {`${dayjs(user?.metadata.fee.validFrom).format("DD.MM.YYYY")} - ${dayjs(user?.metadata.fee.validTo).format("DD.MM.YYYY")}`}
                </React.Fragment>
              )}              
            </Th>
              <Th>{user.metadata?.businessName}</Th>
              <Th>{user.metadata?.companyName}</Th>
              <Th>{user.metadata?.siteUrl}</Th>
              <Th>{user.metadata?.visits ? user.metadata?.visits.counter : '-'}</Th>
              <Td>
                {!user.active ? user?.step : 4} / 4
              </Td>
              <Td>
                {user?.createdAt ? <div>
                  Създаден: {dayjs(user.createdAt).format('DD.MM.YYYY')}
                </div> : ''}
                {user?.updatedAt ? <div>
                  Обновен: {dayjs(user.updatedAt).format('DD.MM.YYYY')}
                </div> : ''}
                {user?.approvedDate ? <div>
                  Одобрен: {dayjs(user.approvedDate).format('DD.MM.YYYY')}
                </div> : ''}
              </Td>
              <Th>{userApproved}
                <div>
                  <Button
                    className="btn waves-effect waves-light"
                    onClick={() => {
                      user.approved = 'Pending'
                      this.onRemoveOpen(user,
                        'Искаш ли да преместиш този приют в \'Чакащи\'?',
                        'Деактивирай приют',
                        ProfessionalActionTypes.DISABLE);
                    }}
                  ><i className="bx bxs-down-arrow font-size-16 align-middle"></i></Button>
                </div>
              </Th>
              <Td>
                <div className="button-items d-flex">
                  <button
                    type="button"
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => {
                      this.onEditOpen(user);
                    }}
                  >
                    <i className="bx bxs-edit font-size-16 align-middle"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-info waves-effect waves-light"
                    onClick={() => {
                      this.onStatisticOpen(user?.metadata?.visits);
                    }}
                  >
                    <i className='bx bx-stats font-size-16 align-middle'></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger waves-effect waves-light"
                    onClick={() => {
                      this.onRemoveOpen(user,
                        'Искаш ли да изтриеш този приют?',
                        'Изтрий приют',
                        ProfessionalActionTypes.REMOVE);
                    }}
                  >
                    <i className="bx bx-trash-alt font-size-16 align-middle"></i>
                  </button>
                </div>
              </Td>
            </Tr>
          );
        }
      });

      return hotelListView;
    } else {
      return null;
    }
  }


  onServiceOpen = (professional) => {
    let defaultServices = {metadata: {services: [{serviceName: '', price: 0, duration: 20}]}}
    if (professional && professional?.metadata && professional?.metadata.services.length) {
      defaultServices = {metadata: {services: professional?.metadata.services}}
    }
    this.setState({
      isServiceEditModalOpen: !this.state.isServiceEditModalOpen,
      editHotel: professional,
      defaultValues: defaultServices
    });
  }

  render() {
    const {
      isEditModalOpen,
      isRemoveModalOpen,
      isStatisticModalOpen,
      removeHotel,
      editHotel,
      title,
      subTitle,
      status
    } =
      this.state;
    const {list, user} = this.props
    return (
      <div className="table-rep-plugin">
        <div className="table-responsive mb-0" data-pattern="priority-columns">
          <Table
            id="tech-companies-1"
            className="table table-striped table-bordered"
          >
            <Thead>
              <Tr>
                <Th data-priority="1">Име </Th>
                <Th data-priority="3">Имейл</Th>
                <Th data-priority="3">Абонамент</Th>
                <Th data-priority="3">Име на бизнеса</Th>
                <Th data-priority="3">Име на фирма</Th>
                <Th data-priority="3">Уебсайт</Th>
                <Th data-priority="3">Посещения</Th>
                <Th data-priority="3">Стъпка от профила</Th>
                <Th data-priority="3">Инфо</Th>
                <Th data-priority="3">Одобрен</Th>
                <Th data-priority="3">Действия</Th>
              </Tr>
            </Thead>
            <Tbody>{this.getHotelsList(list?.users)}</Tbody>
          </Table>
        </div>
        <RemoveList
          data={removeHotel}
          onSubmit={status === ProfessionalActionTypes.DISABLE ? this.onApproveSubmit : this.onRemoveSubmit}
          isRemoveModalOpen={isRemoveModalOpen}
          onCancel={this.onRemoveOpen}
          title={title}
          subTitle={subTitle}
          status={status}
        />

          <ProfessionalEdit
            admin={user}
            data={editHotel}
            onSubmit={this.onApproveSubmit}
            onUpdate={this.onEditSubmit}
            createProfessionalMetaHeadData={this.props.createProfessionalMetaHeadData}
            onDeclineAccount={this.onDeclineAccount}
            isEditModalOpen={isEditModalOpen}
            onCancel={this.onEditOpen}
            removeOrder={this.onRemoveOpen}

          />
        {isStatisticModalOpen && (
          <ShelterStatistic
            data={editHotel}
            isStatisticModalOpen={isStatisticModalOpen}
            onCancel={this.onStatisticOpen}
          />
        )}
      </div>
    );
  }
}

export default connect(({Login}) => {
  return Login
}, {getTypeTranslation, approveProfessional, createProfessionalMetaHeadData})(ShelterList);
